var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.value)?[_c('div',[_vm._v(_vm._s(_vm.formatIndexDate(_vm.value).date))]),_c('div',{staticClass:"mc-datetime"},[_vm._v(" "+_vm._s(_vm.formatIndexDate(_vm.value).time)+" ")])]:[_vm._v(" - ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }